const en = [{
  label: 'Search',
  name: 'search',
  placeholder: 'search...',
  type: 'text',
}, {
  label: 'Period of time',
  name: 'date',
  type: 'range',
}, {
  label: 'Type of action',
  name: 'type',
  type: 'section',
  options: [
    { name: 'All', value: '' },
    { name: 'Access', value: 'access' },
    { name: 'Sharing', value: 'sharing' },
    { name: 'Malfunction', value: 'malfunction' },
    { name: 'Alarm', value: 'alarm' },
    { name: 'Other', value: 'other' },
  ]
}, {
  label: 'Warehouse',
  name: 'warehousesIds',
  type: 'multiSelect',
  options: []
}]

const pl = [{
  label: 'Szukaj',
  name: 'search',
  placeholder: 'szukaj...',
  type: 'text',
}, {
  label: 'Okres czasu',
  name: 'date',
  type: 'range'
}, {
  label: 'Rodzaj akcji',
  name: 'type',
  type: 'section',
  options: [
    { name: 'Wszystkie', value: '' },
    { name: 'Dostęp', value: 'access' },
    { name: 'Udostępnienia', value: 'sharing' },
    { name: 'Awaria', value: 'malfunction' },
    { name: 'Alarm', value: 'alarm' },
    { name: 'Inne', value: 'other' },
  ]
}, {
  label: 'Magazyn',
  name: 'warehousesIds',
  type: 'multiSelect',
  options: []
}]

export { en, pl }